module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_smolinksy_sm-f4a70e322dee79c060b0887f5fbe476f.png";